// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1yACU","fileDisabled":"File_fileDisabled__pk-7c"};